import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './auth'

/** Gate vor allen geschützten Seiten: lädt den Status, leitet ohne Login auf /login um. */
export function ProtectedRoute() {
  const { isLoading, user } = useAuth()
  if (isLoading) return <div className="centered muted">Lädt…</div>
  if (!user) return <Navigate to="/login" replace />
  return <Outlet />
}
